import { FETCH_QUIZ_WITH_ANSWERS, FETCH_BREED_QUIZ_FEATURES, QUIZ_FEATURES_VIA_BREED, FETCH_AVAILABLE_QUIZ_BREED, CREATE_BREED_QUIZ_FEATURES, EDIT_BREED_QUIZ_FEATURES, DELETE_BREED_QUIZ_FEATURES, CREATE_BREED_QUIZ_FEATURES_FROM_FILE,
  FETCH_AVAILABLE_PUPPIES_BASE_ON_QUIZ_ANSWERS, UPDATE_QUIZ } from '../actions';
const initialState = {
  quizWithUser: [],
  updatedQuiz:'',
};

function quizReducer(state = initialState, action) {
  let quizWithUser, breedQuizFeatures, quizFeaturesViaBreed, availableBreed, createdBreedQuizFeatures, editedBreedQuizFeatures, deletedBreedQuizFeatures, createdBreedQuizFeaturesFromFile,updatedQuiz,availablePuppiesUserAnswer;
  switch (action.type) {
    case `${FETCH_QUIZ_WITH_ANSWERS}_PENDING`:
    case `${QUIZ_FEATURES_VIA_BREED}_PENDING`:
    case `${FETCH_BREED_QUIZ_FEATURES}_PENDING`:
    case `${CREATE_BREED_QUIZ_FEATURES}_PENDING`:  
    case `${FETCH_AVAILABLE_QUIZ_BREED}_PENDING`:  
    case `${EDIT_BREED_QUIZ_FEATURES}_PENDING`:  
    case `${DELETE_BREED_QUIZ_FEATURES}_PENDING`:   
    case `${CREATE_BREED_QUIZ_FEATURES_FROM_FILE}_PENDING`: 
    case `${FETCH_AVAILABLE_PUPPIES_BASE_ON_QUIZ_ANSWERS}_PENDING`: 
 
    return { ...state, 
        loading: true,
      };  
      
    case `${FETCH_QUIZ_WITH_ANSWERS}_FULFILLED`:
        quizWithUser = action.payload.data;        
      return { ...state, loading: false, quizWithUser };

     case `${UPDATE_QUIZ}_FULFILLED`:
        updatedQuiz = action.payload.data;
      return { ...state, loading: false, updatedQuiz };
        
    case `${FETCH_QUIZ_WITH_ANSWERS}_REJECTED`:
      return {...state, loading: false, quizWithUserError: action.payload.response.data, state: initialState }; 

    case `${UPDATE_QUIZ}_REJECTED`:
        return {...state, loading: false, updatedQuizError: action.payload.response.data, state: initialState }; 
    case `${CREATE_BREED_QUIZ_FEATURES}_FULFILLED`:
        createdBreedQuizFeatures = action.payload.data;
      return { ...state, loading: false, createdBreedQuizFeatures };

    case `${FETCH_BREED_QUIZ_FEATURES}_FULFILLED`:
        breedQuizFeatures = action.payload.data;
      return { ...state, loading: false, breedQuizFeatures };

    case `${QUIZ_FEATURES_VIA_BREED}_FULFILLED`:
        quizFeaturesViaBreed = action.payload.data;
      return { ...state, loading: false, quizFeaturesViaBreed };   
      
    case `${FETCH_AVAILABLE_QUIZ_BREED}_FULFILLED`:
        availableBreed = action.payload.data;
      return { ...state, loading: false, availableBreed };  
      
    case `${EDIT_BREED_QUIZ_FEATURES}_FULFILLED`:
        editedBreedQuizFeatures = action.payload.data;
      return { ...state, loading: false, editedBreedQuizFeatures };    
    
    case `${DELETE_BREED_QUIZ_FEATURES}_FULFILLED`:
        deletedBreedQuizFeatures = action.payload.data;
      return { ...state, loading: false, deletedBreedQuizFeatures };   

    case `${CREATE_BREED_QUIZ_FEATURES_FROM_FILE}_FULFILLED`:
      createdBreedQuizFeaturesFromFile = action.payload.data;
      return { ...state, loading: false, createdBreedQuizFeaturesFromFile }; 

    case `${FETCH_AVAILABLE_PUPPIES_BASE_ON_QUIZ_ANSWERS}_FULFILLED`:
      availablePuppiesUserAnswer = action.payload.data;
      return { ...state, loading: false, availablePuppiesUserAnswer }; 

    case `${FETCH_QUIZ_WITH_ANSWERS}_REJECTED`:
      return {...state, loading: false, quizWithUserError: action.payload.response.data, state: initialState }; 

    case `${FETCH_BREED_QUIZ_FEATURES}_REJECTED`:
      return {...state, loading: false, breedQuizFeaturesError: action.payload.response.data, state: initialState }; 

    case `${QUIZ_FEATURES_VIA_BREED}_REJECTED`:
      return {...state, loading: false, quizFeaturesViaBreedError: action.payload.response.data, state: initialState }; 

    case `${FETCH_AVAILABLE_QUIZ_BREED}_REJECTED`:
      return {...state, loading: false, availableBreedError: action.payload.response.data, state: initialState }; 
        
    case `${CREATE_BREED_QUIZ_FEATURES}_REJECTED`:     
      return {...state, loading: false, createdBreedQuizFeaturesError: action.payload.response.data, state: initialState };  
      
    case `${CREATE_BREED_QUIZ_FEATURES_FROM_FILE}_REJECTED`:     
      return {...state, loading: false, createdBreedQuizFeaturesFromFileError: action.payload.response.data, state: initialState };  

    case `${FETCH_AVAILABLE_PUPPIES_BASE_ON_QUIZ_ANSWERS}_REJECTED`:     
      return {...state, loading: false, availablePuppiesUserAnswerError: action.payload.response.data, state: initialState };  

    default:
      return state;
  }
}

export default quizReducer;
